import { Login } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { User } from "../../../app/backendTypes";
import { useCanEmployeeLogin } from "../../../app/hooks";
import ErrorChip from "../ErrorChip";
import LoadingChip from "../LoadingChip";

function CanLoginDisplay(props: { user: User }) {
  const { user } = props;

  let reason: string | null = null;
  let skip = false;

  if (!user.vc_id) {
    reason = "NoVismaConnect";
    skip = true;
  }

  const { canLogin, loading, error } = useCanEmployeeLogin(
    user.employee.id,
    skip
  );

  if (loading) return <LoadingChip />;
  if (error) return <ErrorChip error={error} />;

  if (canLogin && canLogin.kind === "No") {
    reason = canLogin.inner.reason;
  }

  if (reason)
    return (
      <Chip icon={<Login />} color="error" label={reason} variant="outlined" />
    );

  return (
    <Chip
      icon={<Login />}
      color="success"
      label="Login OK"
      variant="outlined"
    />
  );
}

export default CanLoginDisplay;
